import '../App.css';
import {css} from "@emotion/css";
import {Button, Card, Divider, Typography} from "@mui/material";
import expo from "../Images/expo-go.png"
import {AppStoreIcon, GooglePlayStoreIcon} from "../Components/StoreIcons";

export default function Demo() {
    const background = css`
      background: rgb(249, 249, 249);
      background: linear-gradient(180deg, rgba(249, 249, 249, 1) 1%, rgba(32, 116, 212, 1) 100%);
      margin-bottom: -8px;
    `
    const hrStyle = css`
      border: 0;
      width: 75%;
      height: 1px;
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
    `
    const mainCard = css`
      width: auto;
      display: inline-block;
      margin-top: 2%;
      margin-bottom: 2%;
      padding-top: 2%;
      padding-bottom: 2%;
    `
    const innerContainer = css`
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    `
    const link = css`
      text-decoration: none;

      &, &:hover, &:visited {
        color: #F08080;
      }`
    const bodyText = css`
      color: #6D6D6D;
`
    const storeContainer = css`
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      @media (max-width: 641px) {
        display: block;
      }
    `
    return (
        <div className="App">
            <div className={background}>
                <Card className={mainCard} variant="outlined">
                    <div className={innerContainer}>
                        <Typography variant="h2" gutterBottom style={{fontWeight: 'bold'}}>
                            Try Our Demo App
                            <hr className={hrStyle}/>
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom className={bodyText}>
                            Download Expo Go on the Google Play Store or App Store and try some of our example
                            components
                            built using React Native. <br/> Simply open the Expo Go app and enter the following url or
                            scan
                            the below QR code to download a test copy.
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <a
                                href="#/"
                                className={link}
                                onClick={() => navigator.clipboard.writeText('exp://exp.host/@savidanttech/savidant-tech-demo?release-channel=default')}
                            >
                                exp://exp.host/@savidanttech/savidant-tech-demo?release-channel=default
                            </a>
                            <Button
                                onClick={() => navigator.clipboard.writeText('exp://exp.host/@savidanttech/savidant-tech-demo?release-channel=default')}
                            >
                                Copy
                            </Button>
                        </Typography>
                        <svg width="45%" height="45%" viewBox="0 0 512 512" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0 8C0 3.58172 3.58172 0 8 0H504C508.418 0 512 3.58172 512 8V504C512 508.418 508.418 512 504 512H8C3.58172 512 0 508.418 0 504V8Z"
                                fill="white"/>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57" shapeRendering="crispEdges"
                                 height="512" width="512" x="0" y="0">
                                <path stroke="#000000"
                                      d="M4 4.5h7m2 0h1m2 0h1m1 0h3m1 0h3m3 0h2m2 0h2m2 0h1m3 0h1m3 0h1m1 0h7M4 5.5h1m5 0h1m2 0h6m1 0h3m1 0h1m1 0h2m1 0h1m4 0h5m3 0h3m1 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m4 0h4m2 0h3m1 0h1m2 0h1m1 0h2m1 0h3m1 0h1m2 0h2m1 0h2m1 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m2 0h1m7 0h2m2 0h1m1 0h4m1 0h2m1 0h1m3 0h3m1 0h1m2 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h1m2 0h2m1 0h1m1 0h2m2 0h1m1 0h5m1 0h2m2 0h2m1 0h3m4 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m10 0h1m3 0h2m3 0h4m1 0h3m1 0h4m3 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M12 11.5h1m2 0h1m1 0h2m1 0h2m1 0h1m1 0h2m3 0h3m1 0h1m1 0h2m1 0h1m1 0h1m1 0h1M6 12.5h2m2 0h4m1 0h1m1 0h6m1 0h1m1 0h5m5 0h5m1 0h1m2 0h2m1 0h1M6 13.5h1m5 0h2m1 0h1m2 0h1m1 0h3m1 0h1m1 0h1m2 0h3m1 0h4m4 0h1m3 0h3m2 0h1M7 14.5h4m1 0h1m1 0h4m1 0h1m3 0h1m1 0h1m3 0h1m2 0h2m2 0h1m1 0h1m1 0h2m1 0h1m1 0h5m1 0h1M5 15.5h2m1 0h2m4 0h1m4 0h1m1 0h3m4 0h3m3 0h1m1 0h3m1 0h1m7 0h3M4 16.5h3m1 0h4m2 0h1m1 0h1m3 0h2m5 0h1m3 0h1m2 0h1m4 0h3m1 0h5m1 0h2M5 17.5h1m1 0h2m5 0h2m3 0h1m3 0h1m1 0h4m2 0h1m1 0h3m1 0h1m1 0h1m1 0h3m3 0h3m1 0h2M4 18.5h1m1 0h1m3 0h4m2 0h2m2 0h1m1 0h1m2 0h8m2 0h1m3 0h1m1 0h3m2 0h2m2 0h1M7 19.5h2m4 0h1m2 0h1m9 0h3m4 0h1m1 0h1m1 0h1m6 0h2m2 0h2m2 0h1M4 20.5h1m2 0h1m1 0h2m2 0h3m1 0h2m1 0h9m3 0h1m1 0h1m1 0h2m3 0h2m2 0h4m2 0h2M6 21.5h3m2 0h1m2 0h3m1 0h1m2 0h1m5 0h1m1 0h1m3 0h2m1 0h1m1 0h1m2 0h1m1 0h1m1 0h2m1 0h3m1 0h1M5 22.5h1m4 0h1m2 0h2m1 0h1m1 0h1m1 0h2m5 0h2m1 0h1m1 0h3m4 0h1m1 0h1m1 0h2m1 0h1m5 0h1M7 23.5h3m1 0h2m1 0h4m2 0h1m3 0h1m2 0h2m1 0h1m1 0h3m1 0h1m1 0h10m1 0h1m1 0h1M4 24.5h1m2 0h1m2 0h4m1 0h2m1 0h2m3 0h1m5 0h1m4 0h3m1 0h1m7 0h2m1 0h1m1 0h1M5 25.5h1m1 0h1m1 0h1m3 0h1m3 0h6m10 0h1m1 0h1m4 0h2m4 0h1m3 0h1M5 26.5h1m2 0h5m4 0h2m1 0h2m1 0h2m1 0h5m1 0h5m1 0h1m2 0h1m2 0h7M4 27.5h2m2 0h1m3 0h1m4 0h2m2 0h2m2 0h2m3 0h2m3 0h1m1 0h4m2 0h2m3 0h5M4 28.5h1m2 0h2m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h2m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m1 0h2m3 0h1m1 0h1m1 0h2m1 0h2M4 29.5h5m3 0h1m1 0h2m2 0h1m2 0h1m1 0h4m3 0h1m6 0h1m1 0h6m3 0h3m1 0h1M4 30.5h1m2 0h7m1 0h5m1 0h1m1 0h10m3 0h1m2 0h11m1 0h1M4 31.5h1m1 0h1m1 0h2m2 0h2m2 0h3m1 0h1m1 0h1m1 0h1m5 0h1m3 0h1m1 0h1m15 0h1M4 32.5h1m2 0h1m2 0h2m2 0h2m2 0h1m3 0h2m2 0h1m1 0h1m1 0h2m1 0h4m2 0h1m1 0h2m1 0h2m1 0h4m1 0h1M5 33.5h2m1 0h1m5 0h3m1 0h3m2 0h1m1 0h1m1 0h1m1 0h2m3 0h1m2 0h2m4 0h1m1 0h1m1 0h1m1 0h1m2 0h1M4 34.5h1m1 0h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m1 0h1m2 0h4m1 0h3m1 0h2m1 0h2m1 0h2m1 0h1m1 0h1m2 0h3m4 0h1M4 35.5h1m3 0h1m2 0h1m1 0h1m1 0h2m3 0h2m1 0h2m3 0h2m3 0h1m1 0h2m5 0h3m1 0h1m1 0h2M4 36.5h1m5 0h5m1 0h2m1 0h3m2 0h4m2 0h4m1 0h1m1 0h2m2 0h2m2 0h1m1 0h2m2 0h1M5 37.5h3m3 0h1m2 0h1m1 0h1m1 0h2m3 0h3m1 0h4m1 0h1m2 0h1m3 0h3m1 0h1m3 0h1m1 0h1M4 38.5h1m2 0h1m2 0h2m1 0h2m3 0h1m1 0h4m1 0h2m2 0h2m1 0h1m3 0h4m3 0h1m4 0h3M6 39.5h2m6 0h2m5 0h1m4 0h2m2 0h3m1 0h1m1 0h3m1 0h1m1 0h2m2 0h7M4 40.5h1m1 0h1m1 0h3m3 0h6m2 0h4m1 0h1m1 0h1m2 0h2m1 0h1m1 0h4m2 0h1m1 0h1m2 0h3m1 0h1M5 41.5h1m1 0h2m2 0h1m1 0h2m5 0h1m3 0h2m1 0h2m1 0h1m2 0h1m1 0h3m4 0h3m2 0h6M5 42.5h1m3 0h2m4 0h2m2 0h3m1 0h2m1 0h1m1 0h5m2 0h1m3 0h2m1 0h1m1 0h2m1 0h1m3 0h1M5 43.5h3m4 0h1m1 0h2m2 0h1m2 0h3m1 0h1m3 0h1m1 0h1m1 0h1m2 0h1m1 0h1m2 0h2m4 0h1m2 0h2M4 44.5h3m3 0h2m2 0h4m3 0h1m4 0h5m1 0h5m1 0h1m5 0h5m2 0h1M12 45.5h1m1 0h1m1 0h2m5 0h1m2 0h1m3 0h2m2 0h1m1 0h2m1 0h1m2 0h3m3 0h1m2 0h2M4 46.5h7m1 0h1m2 0h1m1 0h2m2 0h1m1 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m2 0h1m1 0h2m3 0h1m1 0h1m1 0h2m1 0h2M4 47.5h1m5 0h1m8 0h3m2 0h1m1 0h1m3 0h2m1 0h1m3 0h2m1 0h1m2 0h2m3 0h2m2 0h1M4 48.5h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h7m2 0h5m1 0h1m4 0h1m1 0h1m1 0h1m1 0h7M4 49.5h1m1 0h3m1 0h1m1 0h1m3 0h6m1 0h2m1 0h2m2 0h1m2 0h1m1 0h1m5 0h1m3 0h1m2 0h2m2 0h1M4 50.5h1m1 0h3m1 0h1m1 0h2m3 0h2m1 0h3m2 0h2m2 0h2m1 0h2m1 0h4m1 0h2m3 0h4M4 51.5h1m5 0h1m3 0h4m1 0h3m1 0h1m1 0h1m6 0h7m1 0h2m1 0h3m2 0h3M4 52.5h7m3 0h3m1 0h1m1 0h1m1 0h2m1 0h4m2 0h2m1 0h2m3 0h3m1 0h1m6 0h3"/>
                            </svg>
                            <rect x="211.08771929824562" y="211.08771929824562" width="89.82456140350877"
                                  height="89.82456140350877" fill="black" stroke="white"
                                  strokeWidth="9.482456140350877"/>
                            <svg x="211.08771929824562" y="211.08771929824562" width="89.82456140350877"
                                 height="89.82456140350877" viewBox="0 0 116 116" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M63.9114 35.4964L52.1135 35.4964L30.6671 76.3932L39.9023 81.2706L58.0329 46.7391L76.1169 81.2829L85.333 76.3847L63.9114 35.4964Z"
                                    fill="white"/>
                            </svg>
                        </svg>
                        <Typography variant="subtitle1" gutterBottom className={bodyText}>
                            The demo application presents a login/register form at the beginning, but this is only for
                            example purposes. <br/>No sign in required!
                        </Typography>
                        <Divider/>
                        <div style={{
                            display: 'flex',
                            paddingTop: '1%',
                            marginRight: 'auto',
                            marginLeft: 'auto',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '75%'
                        }}>
                            <a href="https://expo.dev/client"
                               target="_blank"
                               rel="noopener noreferrer">
                                <img style={{width: '100px'}} src={expo} alt="Expo Logo"/>
                            </a>

                            <Divider orientation="vertical" flexItem>
                                <a href="https://expo.dev/client"
                                   target="_blank"
                                   rel="noopener noreferrer" className={link} style={{color: '#6D6D6D'}}>
                                Expo Go
                                </a>
                            </Divider>
                            <div className={storeContainer}>
                                <a style={{minWidth: '150px',}}
                                   href="https://apps.apple.com/us/app/expo-go/id982107779?itsct=apps_box_badge&amp;itscg=30200"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <AppStoreIcon/>
                                </a>
                                <a style={{minWidth: '150px',}}
                                   href='https://play.google.com/store/apps/details?id=host.exp.exponent&referrer=www&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <GooglePlayStoreIcon/>
                                </a>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}
